<script setup lang="ts">
import { computed, ref, watch } from 'vue'

/**
 * 头像图片 + 文字/图标兜底。
 * 地址由后端现签（预签名约 4 小时过期），过期或加载失败时必须退回首字/图标，
 * 不能留一个破图占位；换地址（重新登录、改头像）后重置失败标记，否则新头像永远显示不出来。
 */
const props = defineProps<{
  src?: string
  alt?: string
}>()

const loadFailed = ref(false)
watch(() => props.src, () => { loadFailed.value = false })

const imageUrl = computed(() => (props.src && !loadFailed.value ? props.src : ''))
</script>

<template>
  <img
    v-if="imageUrl"
    :src="imageUrl"
    :alt="props.alt || '用户头像'"
    class="h-full w-full object-cover"
    @error="loadFailed = true"
  />
  <slot v-else />
</template>
